// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"1eedd8d8","239":"4121e86b","453":"4e0ff5ee","455":"0b3aad5b"}[chunkId] + ".chunk.js";
};